type Listener = () => void;

let pendingRequestsCount = 0;
const listeners = new Set<Listener>();

function setPendingRequestsCount(count: number) {
    pendingRequestsCount = count;
    listeners.forEach((listener) => listener());
}

export function getPendingRequestsCount() {
    return pendingRequestsCount;
}

export function subscribeToPendingRequests(listener: Listener) {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}

export async function trackPendingRequest<T>(request: Promise<T>): Promise<T> {
    setPendingRequestsCount(pendingRequestsCount + 1);
    try {
        return await request;
    } finally {
        setPendingRequestsCount(pendingRequestsCount - 1);
    }
}
